webpackJsonp([6],{

/***/ 1018:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_full_js__ = __webpack_require__(1083);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0464616b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_full_vue__ = __webpack_require__(1170);
var normalizeComponent = __webpack_require__(494)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_full_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0464616b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_full_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1071:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/6672276.2a14d13.jpg";

/***/ }),

/***/ 1083:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_backtotop__ = __webpack_require__(1163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_header_view__ = __webpack_require__(1168);



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    BackToTop: __WEBPACK_IMPORTED_MODULE_0_vue_backtotop__["a" /* default */],
    HeadView: __WEBPACK_IMPORTED_MODULE_1__components_header_view__["a" /* default */]
  }
});

/***/ }),

/***/ 1084:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BackToTop',
  props: {
    text: {
      type: String,
      default: 'Voltar ao topo'
    },
    visibleoffset: {
      type: [String, Number],
      default: 600
    },
    visibleoffsetbottom: {
      type: [String, Number],
      default: 0
    },
    right: {
      type: String,
      default: '30px'
    },
    bottom: {
      type: String,
      default: '40px'
    },
    scrollFn: {
      type: Function,
      default: function _default(eventObject) {}
    }
  },
  data: function data() {
    return {
      visible: false
    };
  },
  mounted: function mounted() {
    window.smoothscroll = function () {
      var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(window.smoothscroll);
        window.scrollTo(0, Math.floor(currentScroll - currentScroll / 5));
      }
    };
    window.addEventListener('scroll', this.catchScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.catchScroll);
  },

  methods: {
    /**
     * Catch window scroll event 
     * @return {void}
     */
    catchScroll: function catchScroll() {
      var pastTopOffset = window.pageYOffset > parseInt(this.visibleoffset);
      var pastBottomOffset = window.innerHeight + window.pageYOffset >= document.body.offsetHeight - parseInt(this.visibleoffsetbottom);
      this.visible = parseInt(this.visibleoffsetbottom) > 0 ? pastTopOffset && !pastBottomOffset : pastTopOffset;
      this.scrollFn(this);
    },

    /**
     * The function who make the magics
     * @return {void}
     */
    backToTop: function backToTop() {
      window.smoothscroll();
      this.$emit('scrolled');
    }
  }
});

/***/ }),

/***/ 1085:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    logout: function logout() {
      this.$store.commit('clearState');
      this.$router.push('/login');
    },
    backPage: function backPage() {
      this.$router.push(this.$store.state.historyPage);
    }
  }
});

/***/ }),

/***/ 1163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BackToTop_vue__ = __webpack_require__(1164);
 

/**
 * Check why can't use () => {}
 */
__WEBPACK_IMPORTED_MODULE_0__BackToTop_vue__["a" /* default */].install = function (Vue, options) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__BackToTop_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__BackToTop_vue__["a" /* default */])
}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__BackToTop_vue__["a" /* default */]);


/***/ }),

/***/ 1164:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_BackToTop_vue__ = __webpack_require__(1084);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_386676da_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_BackToTop_vue__ = __webpack_require__(1167);
function injectStyle (ssrContext) {
  __webpack_require__(1165)
}
var normalizeComponent = __webpack_require__(494)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_BackToTop_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_386676da_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_BackToTop_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1165:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1166);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1017)("2b71ab16", content, true, {});

/***/ }),

/***/ 1166:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1016)(true);
// imports


// module
exports.push([module.i, ".back-to-top-fade-enter-active,.back-to-top-fade-leave-active{-webkit-transition:opacity .7s;transition:opacity .7s}.back-to-top-fade-enter,.back-to-top-fade-leave-to{opacity:0}.vue-back-to-top{cursor:pointer;position:fixed;z-index:1000}.vue-back-to-top .default{background-color:#f5c85c;border-radius:3px;color:#fff;height:30px;line-height:30px;text-align:center;width:160px}.vue-back-to-top .default span{color:#fff}.vue-back-to-top--is-footer{bottom:50%!important;position:absolute;-webkit-transform:translateY(50%);transform:translateY(50%)}", "", {"version":3,"sources":["/Users/chakritkanpromkad/Desktop/Sourcetree/Mariminterfood/pos_ui-Develop/node_modules/vue-backtotop/src/styles.css"],"names":[],"mappings":"AACA,8DAEE,+BAAgC,AAChC,sBAAwB,CACzB,AACD,mDAEE,SAAW,CACZ,AACD,iBACE,eAAe,AACf,eAAgB,AAChB,YAAc,CACf,AACD,0BACE,yBAA0B,AAC1B,kBAAmB,AACnB,WAAe,AACf,YAAa,AACb,iBAAkB,AAClB,kBAAmB,AACnB,WAAa,CACd,AACD,+BACE,UAAc,CACf,AACD,4BACE,qBAAuB,AACvB,kBAAmB,AACnB,kCAAmC,AAC3B,yBAA2B,CACpC","file":"styles.css","sourcesContent":["\n.back-to-top-fade-enter-active, \n.back-to-top-fade-leave-active {\n  -webkit-transition: opacity .7s;\n  transition: opacity .7s;\n}\n.back-to-top-fade-enter, \n.back-to-top-fade-leave-to {\n  opacity: 0;\n}\n.vue-back-to-top {\n  cursor:pointer;\n  position: fixed;\n  z-index: 1000;\n}\n.vue-back-to-top .default {\n  background-color: #f5c85c;\n  border-radius: 3px;\n  color: #ffffff;\n  height: 30px;\n  line-height: 30px;\n  text-align: center;\n  width: 160px;\n}\n.vue-back-to-top .default span{\n  color:#ffffff;\n}\n.vue-back-to-top--is-footer {\n  bottom: 50% !important;\n  position: absolute;\n  -webkit-transform: translateY(50%);\n          transform: translateY(50%);\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1167:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"back-to-top-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"vue-back-to-top",style:(("bottom:" + (this.bottom) + ";right:" + (this.right) + ";")),on:{"click":_vm.backToTop}},[_vm._t("default",function(){return [_c('div',{staticClass:"default"},[_c('span',[_vm._v("\n          "+_vm._s(_vm.text)+"\n        ")])])]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_header_js__ = __webpack_require__(1085);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1357ab45_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_view_vue__ = __webpack_require__(1169);
var normalizeComponent = __webpack_require__(494)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_header_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1357ab45_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_view_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1169:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-light bg-white d-flex justify-content-start align-items-center pl-4"},[_c('a-popover',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.currentPath == '/'),expression:"$store.state.currentPath == '/'"}],attrs:{"placement":"right"}},[_c('template',{slot:"content"},[_vm._v("\n      ออกจากระบบ\n    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-danger mr-2",attrs:{"type":"button"},on:{"click":_vm.logout}},[_c('i',{staticClass:"fas fa-sign-out-alt"})])],2),_vm._v(" "),_c('a-popover',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.currentPath !== '/' && _vm.$store.state.historyPage === ''),expression:"$store.state.currentPath !== '/' && $store.state.historyPage === ''"}],attrs:{"placement":"right"}},[_c('template',{slot:"content"},[_vm._v("\n      หน้าหลัก\n    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-danger mr-2",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.push('/')}}},[_c('i',{staticClass:"fas fa-home"})])],2),_vm._v(" "),_c('a-popover',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.currentPath !== '/' && _vm.$store.state.historyPage !== ''),expression:"$store.state.currentPath !== '/' && $store.state.historyPage !== ''"}],attrs:{"placement":"right"}},[_c('template',{slot:"content"},[_vm._v("\n      ย้อนกลับ\n    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-danger mr-2",attrs:{"type":"button"},on:{"click":_vm.backPage}},[_c('i',{staticClass:"fas fa-arrow-circle-left"})])],2),_vm._v(" "),_c('img',{staticClass:"d-inline-block align-top mr-2",attrs:{"src":__webpack_require__(1071),"width":"30","height":"30","alt":""}}),_vm._v(" "),_c('b',{staticClass:"text-danger",staticStyle:{"font-size":"24px"}},[_vm._v("โปรแกรมขาย")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('HeadView'),_vm._v(" "),_c('main',{staticClass:"container-fluid"},[_c('router-view',{staticClass:"container"})],1),_vm._v(" "),_c('back-to-top',{staticClass:"btn-bottom",attrs:{"visibleoffset":"50"}},[_c('i',{staticClass:"fas fa-chevron-up"})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/6.763c9a5ae5bd3f27b00b.js